import React from 'react';
import { Box } from '@mui/system';
import ProfilePicture from '../assets/fpm_prof1.jpg';
import { Container } from '@mui/material';

const Home = (): JSX.Element => {
  return (
    <Box>
      <Box
        component="img"
        sx={{
          border: '1px solid black',
          borderRadius: '15%',
          maxWidth: '250px',
          display: 'block',
          ml: 'auto',
          mr: 'auto',
        }}
        src={ProfilePicture}
      />
      <Box sx={{ textAlign: 'center' }}>
        <h1>Frank P Moley III</h1>
        <h4>
          Engineering Leader & Software Architect | Designing Scalable Cloud Platforms | Kubernetes | Java, Go, Python |
          Systems Design | Security & Reliability | Mentor, Teacher, Perpetual Student
        </h4>
        <p>Designer of systems</p>
        <p>Tamer of clouds</p>
        <p>Student of the world</p>
      </Box>
      <Container></Container>
    </Box>
  );
};

export default Home;
